import { TableSubHeader } from 'src/app/shared/component/data-table/data-table.component';

export const DISBURSEMENT_TABLE_SUB_HEADERS: TableSubHeader[] = [
  { label: 'Code',                    key: 'code',                 minWidth: '160px'},
  { label: 'Name',                    key: 'name',                 minWidth: '160px'},
  { label: 'Institution Type',        key: 'institutionType',      minWidth: '160px'},
  { label: 'Service Fee Percentage',  key: 'serviceFeePercentage', minWidth: '160px'},
  { label: 'Service Fee Fixed',       key: 'serviceFeeFixed',      minWidth: '160px'},
  { label: 'Convenience Fee',         key: 'convenienceFee',       minWidth: '160px'},
  { label: 'Image URL',               key: 'imageUrl',             minWidth: '160px'},
  { label: 'Create Date',             key: 'createDate',           minWidth: '160px'},
  { label: 'Create User',             key: 'createUser',           minWidth: '160px'},
  { label: 'Modify Date',             key: 'modifyDate',           minWidth: '160px'},
  { label: 'Modify User',             key: 'modifyUser',           minWidth: '160px'},
  { label: 'Delete Date',             key: 'deleteDate',           minWidth: '160px'},
  { label: 'Delete User',             key: 'deleteUser',           minWidth: '160px'},
  { label: 'Actions',                 centered: true, sortable: false },
];

export const DISBURSEMENT_INSTITUTION_TYPE_OPTIONS = [
  { label: 'Commercial Bank',                value: 'Commercial Bank' },
  { label: 'Digital Bank',                   value: 'Digital Bank' },
  { label: 'Rural Bank',                     value: 'Rural Bank' },
  { label: 'Thrift Bank',                    value: 'Thrift Bank' },
  { label: 'E-Wallet',                       value: 'E-WALLET' },
  { label: 'Payment Service Provider',       value: 'Payment Service Provider' },
  { label: 'Remittance Provider',            value: 'Remittance Provider' },
  { label: 'Financial Institution',          value: 'Financial Institution' },
  { label: 'Foreign Payment Provider',       value: 'Foreign Payment Provider' },
  { label: 'Crypto Asset Service Provider',  value: 'Crypto Asset Service Provider' },
  { label: 'Others',                         value: 'Others' },
];
